import { ResponseUserAuthData, User } from '@base/features/auth/model/interfaces';
import { StorageKeys } from '../../../utils/constants';
import { ILocalStorage } from '../../storage/interfaces';
import { container } from 'tsyringe';

export const checkUsername = (name: string): boolean => {
  return name.startsWith('*');
};

export const saveResponse = (data: { res: ResponseUserAuthData; user: User | undefined }): void => {
  const localStorage: ILocalStorage = container.resolve('localStorage');
  localStorage.set(StorageKeys.TEMP_DATA, data);
};
